import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const savePurchaseOrderView = {
  name: "savePurchaseOrderView" as const,
  input: z.object({ view: viewSchemas["purchase-orders"] }),
  output: z.object({}),
};
